export default {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    marginBottom: '16px',
  },
  searchSection: {
    display: 'flex',
    gap: '12px',
    alignItems: 'flex-start',
  },
  textarea: {
    width: '100%',
    minHeight: '80px',
    padding: '12px',
    fontSize: '14px',
    borderRadius: '4px',
    border: '1px solid #E2E2FC',
    resize: 'vertical',
    fontFamily: 'inherit',
    '&:focus': {
      outline: 'none',
      borderColor: '#5F60FF',
    },
  },
  searchButton: {
    minWidth: '120px',
    height: '40px',
  },
  resultsSection: {
    border: '1px solid #E2E2FC',
    borderRadius: '8px',
    padding: '16px',
    backgroundColor: '#FAFAFF',
  },
  resultsHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '12px',
    paddingBottom: '12px',
    borderBottom: '1px solid #E2E2FC',
  },
  resultsTitle: {
    fontSize: '14px',
    fontWeight: 600,
    color: '#1A1A2E',
  },
  selectAllContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  postcodeList: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    maxHeight: '200px',
    overflowY: 'auto',
  },
  postcodeChip: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    padding: '6px 12px',
    borderRadius: '16px',
    fontSize: '13px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    border: '1px solid #E2E2FC',
    backgroundColor: '#fff',
    '&:hover': {
      borderColor: '#5F60FF',
    },
  },
  postcodeChipSelected: {
    backgroundColor: '#5F60FF',
    color: '#fff',
    borderColor: '#5F60FF',
  },
  actionsSection: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '16px',
    paddingTop: '16px',
    borderTop: '1px solid #E2E2FC',
  },
  selectedCount: {
    fontSize: '14px',
    color: '#666',
  },
  createButton: {
    minWidth: '180px',
  },
  loadingContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
  },
  errorMessage: {
    color: '#EE4360',
    fontSize: '13px',
    marginTop: '8px',
  },
  progressContainer: {
    padding: '20px',
  },
  progressText: {
    fontSize: '14px',
    marginBottom: '12px',
    textAlign: 'center',
  },
  progressBar: {
    height: '8px',
    borderRadius: '4px',
    backgroundColor: '#E2E2FC',
    overflow: 'hidden',
  },
  progressFill: {
    height: '100%',
    backgroundColor: '#5F60FF',
    transition: 'width 0.3s ease',
  },
  noResults: {
    padding: '20px',
    textAlign: 'center',
    color: '#666',
    fontSize: '14px',
  },
  helperText: {
    fontSize: '12px',
    color: '#888',
    marginTop: '4px',
  },
}
